require('./app');

import VU from "./validation";

/*!
 * Форма "Вход"
 */
(($) => {
	"use strict";

	VU.searchRequired();

	$('#popup-oauth-vk').click((e) => {
		let _this = $(e.currentTarget)
		let clientId = _this.data('clientId');
		let redirectUri = _this.data('redirectUri');
		let state = _this.data('state');

		let authWindow = window.open(`https://oauth.vk.com/authorize` +
			`?client_id=${clientId}` +
			`&display=popup` +
			`&redirect_uri=${redirectUri}` +
			`&scope=email` +
			`&response_type=code` +
			`&state=${state}` +
			`&revoke=1`, '', 'width=655,height=430');

		let interval = setInterval(() => {
			if (authWindow.closed) {
				clearInterval(interval);
				window.location.replace('/profile');
			}
		}, 1000)
	});

	$('#popup-oauth-ok').click((e) => {
		let _this = $(e.currentTarget)
		let clientId = _this.data('clientId');
		let redirectUri = _this.data('redirectUri');
		let state = _this.data('state');
		let uri = encodeURI(`https://connect.ok.ru/oauth/authorize` +
			`?client_id=${clientId}` +
			`&scope=VALUABLE_ACCESS;PHOTO_CONTENT;GET_EMAIL` +
			`&response_type=code` +
			`&redirect_uri=${redirectUri}` +
			`&layout=w` +
			`&state=${state}`)

		let authWindow = window.open(uri, '', 'width=655,height=430');

		let interval = setInterval(() => {
			if (authWindow.closed) {
				clearInterval(interval);
				window.location.replace('/profile');
			}
		}, 1000)
	});
})($);
